<div class="container">
  <loader></loader>
  <div class="row tel-encabezado-pagina">
    <div class="col-12">
      <h3 class="tel-titulo-pagina">
        <strong>{{ 'DISPOSITIVOS.TITULO' | translate }}</strong>
      </h3>
    </div>
  </div>
  <div class="row">
    <div class="separador"></div>
  </div>

  <div class="eventos-contenido" data-simplebar>
    <div *ngFor="let dispositivo of listaDispositivosTodos" class="list-group-item btn col-12 dispositivo">
      <div class="row">
        <div class="col colNombreDispositivo">
          <img [src]="'assets/images/' + dispositivo['icono']" class="icono" />
          <div class="dispositivoInfo">
            {{ 'DISPOSITIVOS.' + dispositivo['nombre'] | translate }}
          </div>
        </div>

        <div class="col">
          <div *ngIf="tieneHomeDelivery(dispositivo)">
            <i
              class="icon-home_delivery icono icono_home_delivery"
              #popOverHomeDelivery="ngbPopover"
              [ngbPopover]="tipContent"
              [placement]="['top', 'left', 'right', 'auto']"
              container="body"
              popoverClass="infoPopover"
              triggers="manual"
              (mouseenter)="abrirInfoPopover(popOverHomeDelivery)"
              (click)="eventoClickInfoPopover(popOverHomeDelivery)"
            >
            </i>
          </div>
        </div>
        <div class="col botones-vinculacion-info">
          <div *ngIf="estaVinculado(dispositivo)" class="contenedor-vinculacion">
            <div class="info-vinculacion">
              <span class="dispositivoVinculado">
                {{ 'DISPOSITIVOS.VINCULACION.VINCULADO' | translate }} {{ mostrarFecha(dispositivo) }}
              </span>
            </div>
            <button
              *ngIf="tieneBotonVinculacion(dispositivo)"
              class="btn btn-success-red boton-panico"
              type="button"
              (click)="confirmarDesvincular(dispositivo['nombre'])"
            >
              {{ 'DISPOSITIVOS.DESVINCULACION.DESVINCULAR' | translate }}
            </button>
          </div>
          <div *ngIf="!estaVinculado(dispositivo)">
            <div class="info-vinculacion">
              <span *ngIf="!tieneBotonVinculacion(dispositivo)" class="dispositivoNoVinculado">
                {{ 'DISPOSITIVOS.VINCULACION.NOVINCULADO' | translate }}
              </span>
              <button
                *ngIf="tieneBotonVinculacion(dispositivo)"
                class="btn btn-primary"
                type="button"
                (click)="avisoParaVincular(dispositivo['nombre'])"
              >
                {{ 'DISPOSITIVOS.VINCULACION.VINCULAR' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #tipContent>
  <app-home-delivery></app-home-delivery>
</ng-template>
